import './styles.css';
import SvgIcon, { iconList } from '../../share/components/iconSVG';
import { Record, RecordCircle } from 'iconsax-react'
import useSearchFlights from "../../../viewModels/flights/search.flights.viewModel";
import DesinitySearcher, { desinitySearcherTypes } from '../components/desinitySearcher';
import FlightPassengerManagement from '../components/ flightPassengerManagement';
import FlightsDateGoing from '../../../../Components/FlightsDateGoing/FlightsDateGoing';

function SearchFlights({ accompanied = true, isIframe=false }) {
  const {
    cardRefPlace,
    cardRefPassenger,
    cardRefDate,
    isRoundTrip,
    setIsRoundTrip,
    buttonDisable,
    searcherFlight,

    //ciudades
    //ida
    isCardRefOrigin,
    setIsCardRefOrigin,
    selectedOrigin,
    getSelectedOrigin,

    //retorno
    isCardRefDestination,
    setIsCardRefDestination,
    selectedDestination,
    getSelectedDestination,
    //fechas
    dateGoingSelected,
    setDateGoingSelected,
    dateReturnSelected,
    setDateReturnSelected,
    isCardRefDate,
    setIsCardRefDate,
    setDateGoingSelectedApi,
    setDateReturnSelectedApi,

    //pasajeros
    isManagingPassengers,
    setIsManagingPassengers,
    passengersSelecteds,
    getPassengersSelecteds,
    finishProcess,
    ellipsisText,
  } = useSearchFlights(isIframe);

  return (
    <div className='searchFlightsContainer'>
      <div className='searchFlightsContainerHeader'>
        <div className='searchFlightsRow'>
          <div className='searchFlightsContainerHeaderOption'>
            <SvgIcon name={iconList.IconPlane} color={'#004274'} size={30} />
            <p className='searchFlightsContainerHeaderOptionTextBig'>Reserva tu vuelo</p>
          </div>
          {/* <div className='searchFlightsContainerHeaderOption'>
            <SvgIcon name={iconList.IconHotel} color={'#004274'} size={30} />
            <p className='searchFlightsContainerHeaderOptionTextBig'>Hotel</p>
          </div>
          <div className='searchFlightsContainerHeaderOption'>
            <SvgIcon name={iconList.IconTravel} color={'#004274'} size={30} />
            <p className='searchFlightsContainerHeaderOptionTextBig'>Paquetes</p>
          </div> */}
        </div>

        <div className={`${accompanied ? 'searchFlightsColumn' : 'searchFlightsRow'}`} >
          <div className='searchFlightsContainerHeaderOption' onClick={() => setIsRoundTrip(false)}>
            {isRoundTrip
              ? <Record size="15" color="#104172" />
              : <RecordCircle size="15" color="#104172" variant="Bold" />
            }
            <p className='searchFlightsContainerHeaderOptionTextSmall'>Solo ida</p>
          </div>
          <div className='searchFlightsContainerHeaderOption' onClick={() => setIsRoundTrip(true)}>
            {isRoundTrip
              ? <RecordCircle size="15" color="#104172" variant="Bold" />
              : <Record size="15" color="#104172" />
            }
            <p className='searchFlightsContainerHeaderOptionTextSmall'>Ida y vuelta</p>
          </div>
        </div>
      </div>

      <div className={`${accompanied ? 'searchFlightsContainerBodyVertical' : 'searchFlightsContainerBody'}`}>
        <div id={`${accompanied ? 'width_B' : 'width_A'}`} onClick={() => setIsCardRefOrigin(true)}>
          <div className='searchFlightsContainerBodyBorder'>
            <div className='searchFlightsContainerBodyOptionTexts'>
              <p className='searchFlightsContainerBodyOptionTextSmall'>Origen</p>
              {selectedOrigin === selectedDestination
                ? <p className='searchFlightsContainerBodyOptionTextBig' style={{ color: 'red' }}>{ellipsisText('Cambia tu origen', 17)}</p>
                : <p className='searchFlightsContainerBodyOptionTextBig'>{ellipsisText(selectedOrigin, 17)}</p>
              }
            </div>
            <SvgIcon name={iconList.IconPinMap} color={'#004274'} size={30} />
          </div>
          {isCardRefOrigin &&
            <div className='searchFlightsContainerPlace'
              ref={cardRefPlace}
            >
              <DesinitySearcher type={desinitySearcherTypes.origin} change={getSelectedOrigin} />
            </div>}
        </div>

        <div id={`${accompanied ? 'width_B' : 'width_A'}`} onClick={() => setIsCardRefDestination(true)}>
          <div className='searchFlightsContainerBodyBorder' >
            <div className='searchFlightsContainerBodyOptionTexts'>
              <p className='searchFlightsContainerBodyOptionTextSmall'>Destino</p>
              {selectedOrigin === selectedDestination
                ? <p className='searchFlightsContainerBodyOptionTextBig' style={{ color: 'red' }}>{ellipsisText('Cambia tu destino', 17)}</p>
                : <p className='searchFlightsContainerBodyOptionTextBig'>{ellipsisText(selectedDestination, 17)}</p>
              }
            </div>
            <SvgIcon name={iconList.IconPinMap} color={'#004274'} size={30} />
          </div>
          {isCardRefDestination &&
            <div className='searchFlightsContainerPlace'
              ref={cardRefPlace}
            >
              <DesinitySearcher type={desinitySearcherTypes.destination} change={getSelectedDestination} />
            </div>}
        </div>

        <div className={`searchFlightsRow ${accompanied ? 'searchFlightsContainerRowAlfa' : 'searchFlightsContainerRowBeta'}`}>
          <div className='searchFlightsContainerBodyBorder' id='width_C' onClick={() => setIsCardRefDate(true)}>
            <div className='searchFlightsContainerBodyOptionTexts'>
              <p className='searchFlightsContainerBodyOptionTextSmall'>fecha</p>
              <p className='searchFlightsContainerBodyOptionTextBig'>{dateGoingSelected}</p>
            </div>
            <SvgIcon name={iconList.IconCalendar} color={'#004274'} size={30} />
          </div>

          <div
            className='searchFlightsContainerBodyBorder'
            id='width_C'
            onClick={() => isRoundTrip && setIsCardRefDate(true)}
            style={{ opacity: !isRoundTrip? 0.25:1}}
          >
            <div className='searchFlightsContainerBodyOptionTexts'>
              <p className='searchFlightsContainerBodyOptionTextSmall'>Fecha </p>
              <p className='searchFlightsContainerBodyOptionTextBig'>{dateReturnSelected}</p>
            </div>
            <SvgIcon name={iconList.IconCalendar} color={'#004274'} size={30} />
          </div>

          {isCardRefDate &&
            <div className='searchFlightsContainerDate'>
              <FlightsDateGoing
                oneWay={!isRoundTrip}
                setOneWay={setIsRoundTrip}
                roundTrip={isRoundTrip}
                setRoundTrip={setIsRoundTrip}
                setDateGoing={setIsCardRefDate}
                dateGoing={isCardRefDate}
                cardRef={cardRefDate}
                setDateGoingSelected={setDateGoingSelected}
                setDateGoingSelectedApi={setDateGoingSelectedApi}
                setDateSreturnSelected={setDateReturnSelected}
                setDateSreturnSelectedApi={setDateReturnSelectedApi}
                searcherFlight={searcherFlight}
              />
            </div>
          }
        </div>

        <div id={`${accompanied ? 'width_B' : 'width_A'}`} onClick={() => setIsManagingPassengers(true)}>
          <div className='searchFlightsContainerBodyBorder'>
            <div className='searchFlightsContainerBodyOptionTexts'>
              <p className='searchFlightsContainerBodyOptionTextSmall'>Pasajeros</p>
              <p className='searchFlightsContainerBodyOptionTextBig'>Número Pasajeros</p>
            </div>
            <SvgIcon name={iconList.IconPeoples} color={'#004274'} size={30} />
          </div>

          {isManagingPassengers &&
            <div className='searchFlightsContainerPlace' style={{ width: 300 }} ref={cardRefPassenger} >
              <FlightPassengerManagement
                value={passengersSelecteds}
                onChange={getPassengersSelecteds}
                finishProcess={finishProcess}
              />
            </div>
          }

        </div>
        <button disabled={buttonDisable} onClick={searcherFlight} className='searchFlightsContainerBodyBorder' id={`${accompanied ? 'width_E' : 'width_D'}`}>
          <SvgIcon name={iconList.IconSearch} color={buttonDisable ? '#CCCCCC' : '#004274'} size={30} />
        </button>
      </div>
    </div>
  )
}

export default SearchFlights;
